import { render, staticRenderFns } from "./cancellation.vue?vue&type=template&id=ab50e072&"
import script from "./cancellation.vue?vue&type=script&lang=js&"
export * from "./cancellation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports